import React from 'react';

interface User {
  id: number;
  name: string;
  email: string;
  role: string;
  lastLogin: string;
}

const UserManagement = () => {
  const users: User[] = [
    {
      id: 1,
      name: 'Admin User',
      email: 'admin@example.com',
      role: 'Administrator',
      lastLogin: '2023-04-03 09:15'
    },
    {
      id: 2,
      name: 'John Doe',
      email: 'john@example.com',
      role: 'Editor',
      lastLogin: '2023-04-02 16:30'
    },
    // Add more sample users as needed
  ];

  return (
    <div className="content-section">
      <div className="content-header">
        <h2>Users</h2>
        <p>Manage user accounts and permissions</p>
        <button className="add-button">Add User</button>
      </div>
      <div className="user-table-container">
        <table className="user-table">
          <thead>
            <tr>
              <th>User</th>
              <th>Email</th>
              <th>Role</th>
              <th>Last Login</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map(user => (
              <tr key={user.id}>
                <td>
                  <div className="user-info">
                    <div className="user-avatar">
                      {user.name.charAt(0)}
                    </div>
                    <span>{user.name}</span>
                  </div>
                </td>
                <td>{user.email}</td>
                <td>
                  <span className={`role-badge ${user.role.toLowerCase()}`}>
                    {user.role}
                  </span>
                </td>
                <td>{user.lastLogin}</td>
                <td>
                  <div className="action-buttons">
                    <button className="action-btn edit">
                      Edit
                    </button>
                    <button className="action-btn delete">
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserManagement; 